import type { ReactNode } from 'react';
import { Group, Text } from '@mantine/core';

import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';

interface FormPanelTitleProps {
  /** Title text/content */
  children: ReactNode;
  /** Optional trailing element rendered next to the title (e.g. AutoSaveIndicator) */
  indicator?: ReactNode;
}

/**
 * Standard SlidePanel form/panel title — 18px semibold, matching the panel
 * detail header (`TaskDetailsHeader`) and the form-header-standard. Pass it via
 * the SlidePanel `headerTitle` prop. Single source of truth for the title's
 * typography so the three form wizards don't each re-declare it.
 */
export function FormPanelTitle({ children, indicator }: FormPanelTitleProps) {
  const title = (
    <Text size="lg" fw={FONT_WEIGHT_SEMIBOLD} truncate>
      {children}
    </Text>
  );

  if (!indicator) return title;

  return (
    <Group gap="xs" align="center" wrap="nowrap">
      {title}
      {indicator}
    </Group>
  );
}
